// most used screen resolutions
// https://gs.statcounter.com/screen-resolution-stats
export const BREAKPOINT = {
  mobile: {
    min: 375,
    max: 767
  },
  tablet: {
    min: 768,
    mid: 1023,
    max: 1279
  },
  desktop: {
    min: 1280,
    max: 1440
  }
};

export const DEVICE = {
  mobile: {
    min: `@media (max-width: ${BREAKPOINT.mobile.min}px)`,
    max: `@media (max-width: ${BREAKPOINT.mobile.max}px)`
  },
  tablet: {
    min: `@media (max-width: ${BREAKPOINT.tablet.min}px)`,
    mid: `@media (max-width: ${BREAKPOINT.tablet.mid}px)`,
    max: `@media (max-width: ${BREAKPOINT.tablet.max}px)`
  },
  desktop: {
    min: `@media (max-width: ${BREAKPOINT.desktop.min}px)`,
    max: `@media (max-width: ${BREAKPOINT.desktop.max}px)`
  }
};
